import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { listAgentCustomersFinancialSummary } from "../actions";
import { resolveErrorMessage } from "../util";

export const useListCustomersFinancialSummary = ({
  searchByText,
  searchById,
  situations,
}) => {
  const currentUser = useSelector((state) => state.user.user.me);
  const [customersFinancialSummary, setCustomersFinancialSummary] = useState();
  const [totals, setTotals] = useState({
    totalCommission: 0,
    totalCustody: 0,
    totalCustomers: 0,
    totalActiveContracts: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await listAgentCustomersFinancialSummary({
          nameOrEmail: searchByText,
          userId: searchById,
          customerSituation: situations,
        });
        const { customers, totals } = data;
        const hasCustomers = totals?.totalCustomers;

        if (!hasCustomers) {
          const hasFiltersApplied = searchByText?.length || searchById?.length || situations?.length > 0;
          const errorMessage = hasFiltersApplied ? "app.users.not.filter" : "app.user.clients.empty";
          throw new Error(errorMessage);
        }

        setCustomersFinancialSummary(customers);
        setTotals(totals);
      } catch (err) {
        const errorMessage = resolveErrorMessage(err);
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    if (currentUser) {
      fetchCustomers();
    }
  }, [currentUser, searchByText, searchById, situations]);

  return { customersFinancialSummary, totals, loading, error };
};

export default useListCustomersFinancialSummary;
